@if (applicantNotifications.showTemplate) {
  <div class="common-lateral-panel"
    [ngClass]="{'common-lateral-panel--expand': applicantNotifications.fullScreen}">
    <div class="common-section-title__lp-container-sidemenu">
      <div class="common-section-title__lp-container-title">
        <div class="common-section-title__lp-title-icon">
          <i class="lf-icon-news common-icon__lg"
            [ngClass]="{'common-icon__main': !isLanding}"></i>
          <span class="common-section-title__lp-label-text"
            [afTranslate]="skin === 'icam-red'?'icam-queries.answer-to-query':'icam-queries.notifications-to-requester'">_Notificaciones al solicitante</span>
        </div>
      </div>
      @if (skin !== 'icam-red') {
        <div class="common-section-title__lp-container-subtitle">
          <span [afTranslate]="'icam-queries.custom-alerts-registry'">_Registro de salida de alertas</span>
        </div>
      }
    </div>
    <div class="common-lateral-panel__body">
      <ul class="common-lateral-panel__list-items">
        @for (notification of applicantNotifications.notificationList | afOrderBy:['scheduledTime', 'name']:true; track $index) {
          <li class="common-lateral-panel__item-cursor"
            [attr.disabled]="userPermissions==='none'?true:null"
            (click)="showNotification(notification)">
            <i class="lf-icon-news common-icon__md common-icon__main"></i>
            <div class="common-lateral-panel__document-text-info">
              <span-tooltip class="common-lateral-panel__item-text common-lateral-panel__item-text--flex"
                [text]="notification.name">
              </span-tooltip>
              <span-tooltip class="common-lateral-panel__item-text"
                [text]="notification.scheduledTime | convertDate: 'without-time'">
              </span-tooltip>
              @if (!isLanding && userPermissions !== 'none') {
                <button class="common-lateral-panel__button-action"
                  pTooltip="{{'icam-queries.resend' | afTranslate}}"
                  tooltipPosition="top"
                  (click)="reSendNotification(notification, $event)">
                  <i class="lf-icon-send common-icon__md"></i>
                </button>
              }
            </div>
          </li>
        }
      </ul>
    </div>
    <div class="common-lateral-panel__expand-block">
      <div class="common-lateral-panel__expand-total-block">
        <p class="common-lateral-panel__expand-total-text">
          <span [afTranslate]="'common.total'">_Total</span>
          <span class="pr-1">:</span>
          <span>{{applicantNotifications.notificationList?.length}}</span>
        </p>
      </div>
      <button class="common-button__expand-toned"
        (click)="applicantNotifications.fullScreen = !applicantNotifications.fullScreen">
        <i class=" common-icon__md"
        [ngClass]="applicantNotifications.fullScreen? 'lf-icon-angle-up': 'lf-icon-angle-down'"></i>
        <span class="common-button__expand-label-text">
        {{applicantNotifications.fullScreen?'Colapsar':'Expandir'}}</span>
      </button>
    </div>
  </div>
}
